import { j as o } from "../accordion/Accordion-CrPiD_81.mjs";
import { C as s } from "./Core-BrDaupPg.mjs";
const i = ({ children: r }) => /* @__PURE__ */ o.jsx(s, { brand: "strm", children: r });
export {
  i as S
};
